(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			const $slider = $(this);

			if ($slider.hasClass("slider_started")) {
				return "";
			}
			if ($(".announcement-bar")) {
				$slider.addClass("slider_started");
			}

			const announcementId = $slider.data("announcement-id");
			const enableAutoplay = String($slider.data("autoplay")) === "true";
			const autoplayDelay = Number($slider.data("autoplay-delay")) || 5000;
			const swiperOptions = {
				loop: false,
				navigation: {
					nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
					prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
				},
			};

			if (enableAutoplay) {
				swiperOptions.autoplay = {
					delay: autoplayDelay,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				};
			}

			new Swiper(
				`.announcement-js-${announcementId}`,
				swiperOptions
			);
		});
	};

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
